import { trainingVersionRepository } from "../../../providers/repositories/trainingVersionRepository";
import { TrainingVersion } from "../entities/TrainingVersion";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const updateTrainingVersionOrderUseCase = {
  async exec(list: TrainingVersion[]): Promise<boolean> {
    try {
      await trainingVersionRepository.updateOrder(list);
      toast.success(t("action.updateSuccess"));
      return true;
    } catch (error) {
      Logger.error("updateTrainingVersionOrderUseCase", error);
      toast.error(t("action.updateError"));
    }
    return false;
  },
};
